import axios from 'axios'
import AmountInput from 'components/AmountInput'
import CustomButton from 'components/Buttons/CustomButton'
import PMBProjectSelections from 'components/PMBProjectSelections'
import ModalAddProject from 'features/private-views/project/ModalAddProject'
import { setIsModalOpenAddProject } from 'features/private-views/project/projectSlice'
import useAutoFetchPublicVersion from 'hooks/useAutoFetchPublicVersion'
import { useEffect, useRef, useState } from 'react'
import { AlertCircle, ExternalLink, FilePlus, Plus, Trash2, X } from 'react-feather'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import SelectInputWithTestId from 'components/PMBSelect/SelectInputWithTestId'
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Spinner,
} from 'reactstrap'
import { uploadFile } from 'features/private-views/sell-commodity/sellCommodityAction'
import { useSnackbar } from 'notistack'
import { apiEndpoint } from '../../utility/Utils'
import { setTotal } from './commodityPurchaseSlice'
import { useNavigate } from 'react-router-dom'
import { URL_PROJECTS_MENU } from 'utils/pathUrl'

const ComodityForm = ({
  handleFinished,
  title,
  isSet,
  handleCbData,
  setDataDraft,
  dataDraft,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const selectRefs = useRef([])
  const [shouldFocus, setShouldFocus] = useState(false)
  const autoFetchPublicVersion = useAutoFetchPublicVersion()
  const [comodities, setComodities] = useState([{ id: 1 }])
  const [dataComodities, setDataComodities] = useState([
    { unit: { value: 'Kg', label: 'Kg' } },
  ])
  const [notes, setNotes] = useState('')
  const [selectedProject, setSelectedProject] = useState(null)
  const [customNumber, setCustomNumber] = useState('')
  const [listComodities, setListComodities] = useState([])
  const [errMsg, setErrMsg] = useState('')
  const [isDraftLoaded, setIsDraftLoaded] = useState(false)
  const [additionalFiles, setAdditionalFiles] = useState([])
  const [additionalFileNames, setAdditionalFileNames] = useState([])
  const [isUploadingDoc, setIsUploadingDoc] = useState(false)
  const docFileInputRef = useRef(null)
  const { enqueueSnackbar } = useSnackbar()

  const handleDocFileChange = async (e) => {
    setIsUploadingDoc(true)
    const newFiles = []
    const newUrls = []

    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i]
      const fileId = Date.now() + i
      const tempFile = {
        id: fileId,
        fileName: file.name,
        fileSize: file.size,
      }

      const isDuplicate = additionalFileNames.some(
        (existingFile) =>
          existingFile.fileName === file.name &&
          existingFile.fileSize === file.size,
      )
      if (isDuplicate) {
        enqueueSnackbar(
          `File dengan nama "${file?.name}" sudah diunggah sebelumnya.`,
          {
            variant: 'error',
          },
        )
        continue
      }

      try {
        const res = await dispatch(uploadFile(file)).unwrap()
        const uploadedUrl =
          res?.url || res?.data?.url || (typeof res === 'string' ? res : '')
        if (!uploadedUrl) {
          throw new Error(
            'Respon server upload tidak memiliki URL file yang valid',
          )
        }
        newFiles.push({ ...tempFile, url: uploadedUrl })
        newUrls.push({ id: fileId, fileUrl: uploadedUrl })
      } catch (error) {
        enqueueSnackbar(
          `Gagal mengunggah file ${file.name}: ${error?.message || error}`,
          {
            variant: 'error',
          },
        )
      }
    }

    setAdditionalFileNames((prev) => [...prev, ...newFiles])
    setAdditionalFiles((prev) => [...prev, ...newUrls])
    setIsUploadingDoc(false)
    e.target.value = null
  }

  const { token } = useSelector((e) => e.auth)
  const { isModalOpenAddProject } = useSelector((e) => e.project)

  const intl = useIntl()

  const handleSelectedProject = (project) => {
    setSelectedProject(project)
  }

  const toggleOpenCloseAddProject = () => {
    dispatch(setIsModalOpenAddProject(!isModalOpenAddProject))
  }

  const handleChange = (key, e, index) => {
    setDataComodities((prevValues) => {
      const newData = [...prevValues]
      newData[index] = {
        ...newData[index],
        [key]: e,
        totalPrice:
          key === 'price' && dataComodities[index]?.quantity
            ? Number(
                e?.replace?.(/\./g, '')?.replace?.(/\,/g, '.')?.slice?.(0, 15),
              ) *
              Number(
                newData[index]?.quantity
                  ?.replace?.(/\./g, '')
                  ?.replace?.(/\,/g, '.')
                  ?.slice?.(0, 15),
              )
            : key === 'quantity' && dataComodities[index]?.price
              ? Number(
                  newData[index]?.price
                    ?.replace?.(/\./g, '')
                    ?.replace?.(/\,/g, '.')
                    ?.slice?.(0, 15),
                ) *
                Number(
                  e
                    ?.replace?.(/\./g, '')
                    ?.replace?.(/\,/g, '.')
                    ?.slice?.(0, 15),
                )
              : (dataComodities[index]?.totalPrice ??
                newData[index]?.totalPrice),
      }
      return newData
    })
  }

  const handleAddComodity = () => {
    addComodity()
    // setShouldFocus(true)
  }

  const addComodity = () => {
    const newId = comodities.length + 1
    setComodities([...comodities, { id: newId }])
    setDataComodities((prev) => [
      ...prev,
      {
        unit: { value: 'Kg', label: 'Kg' },
        quantity: '',
        price: '',
        totalPrice: 0,
        comodity: null,
      },
    ])
  }

  const removeComodity = (id) => {
    setComodities(comodities.filter((comodity) => comodity.id !== id))

    const indexToRemove = id - 1
    setDataComodities(dataComodities.filter((_, idx) => +idx !== indexToRemove))
  }

  const handleLastPick = (e) => {
    const newListComodities = [...listComodities]

    const updatedOptions = newListComodities[0]?.options?.filter(
      (item) => item.id !== e.id,
    )

    updatedOptions.unshift(e)

    if (updatedOptions.length > 5) {
      const removedItem = updatedOptions.pop()

      newListComodities[1] = {
        ...newListComodities[1],
        options: [...newListComodities[1].options, removedItem],
      }
    }

    newListComodities[0] = {
      ...newListComodities[0],
      options: updatedOptions,
    }

    newListComodities[1] = {
      ...newListComodities[1],
      options: newListComodities[1].options.filter((item) => item.id !== e.id),
    }

    localStorage.setItem(
      'lastPickedCommoditiesBuy',
      JSON.stringify(updatedOptions),
    )

    setListComodities(newListComodities)
  }

  const getComodities = async () => {
    try {
      if (listComodities.length < 1) {
        // LOCAL STORAGE
        const storedFrequentItems =
          JSON.parse(localStorage.getItem('lastPickedCommoditiesBuy')) || []

        // GET FREQUENT ITEMS FROM API
        let frequentItemsFromAPI = []
        try {
          const resFrequent = await axios.get(
            `${apiEndpoint}/api/v1/bussines/item-frequent?type=buy`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )

          frequentItemsFromAPI = resFrequent.data.map((e) => ({
            value: e.id,
            label: e.nameItem,
            id: e.id,
            img: e.linkFoto,
            sku: e.SKU,
            agencyModel: e.agencyModel,
          }))
        } catch {
          // Error fetching frequent items
        }

        // GET ALL ITEMS FROM API
        const { data } = await axios.get(
          `${apiEndpoint}/api/v1/bussines/items?origin=true&sortby=nameItem&sortdir=asc`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        let allItems = data.items
        if (data.totalItems > data.items.length) {
          const res = await axios.get(
            `${apiEndpoint}/api/v1/bussines/items?origin=true&sortby=nameItem&sortdir=asc&size=${data.totalItems}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          allItems = res.data.items
        }

        // LOOKUP
        const allItemsMap = new Map()
        allItems.forEach((item) => {
          allItemsMap.set(item.id, {
            value: item.id,
            label: item.nameItem,
            id: item.id,
            img: item.linkFoto,
            sku: item.SKU,
            agencyModel: item.agencyModel,
          })
        })

        // UPDATE AND VALIDATE STORED FREQUENT ITEMS
        const updatedStoredItems = storedFrequentItems
          .map((storedItem) => {
            // CHECK IF ITEM STILL EXISTS IN MASTER ITEMS
            const validItem = allItemsMap.get(storedItem.id)
            if (!validItem) {
              return null
            }

            // UPDATE WITH LATEST DATA FROM MASTER ITEMS
            return {
              ...validItem,
            }
          })
          .filter((item) => item !== null)

        // MERGE WITH FREQUENT ITEM FROM API, AVOIDING DUPLICATES
        const mergedFrequentItems = [...updatedStoredItems]

        // ADD API FREQUENT ITEMS THAT ARE NOT ALREADY IN STORED ITEMS
        frequentItemsFromAPI.forEach((apiItem) => {
          const existsInStored = updatedStoredItems.some(
            (stored) => stored.id === apiItem.id,
          )
          if (!existsInStored) {
            mergedFrequentItems.push(apiItem)
          }
        })

        // LIMIT TO 5 ITEMS AND ENSURE UNIQUENESS
        const finalFrequentItems = mergedFrequentItems
          .filter(
            (item, index, self) =>
              index === self.findIndex((i) => i.id === item.id),
          )
          .slice(0, 5)

        // UPDATE LOCAL STORAGE WITH VALIDATED AND UPDATED FREQUENT ITEMS
        localStorage.setItem(
          'lastPickedCommoditiesBuy',
          JSON.stringify(finalFrequentItems),
        )

        // PREPARE ALL OTHER ITEMS (EXCLUDING FREQUENT ITEMS)
        const allMappedItems = allItems
          .map((e) => ({
            value: e.id,
            label: e.nameItem,
            id: e.id,
            img: e.linkFoto,
            sku: e.SKU,
            agencyModel: e.agencyModel,
          }))
          .filter(
            (item) =>
              !finalFrequentItems.some((frequent) => frequent.id === item.id),
          )

        setListComodities([
          {
            label: 'TERAKHIR/SERING DIPILIH',
            options: finalFrequentItems,
          },
          {
            label: 'SEMUA BARANG',
            options: allMappedItems,
          },
        ])
      }
    } catch {
      // Error fetching commodities
    }
  }

  const handleChangeInputSeparator = (data, name, idx) => {
    if (name === 'price' && data === '0') {
      data = ''
    }

    if (data !== dataComodities[idx]?.[name]) {
      handleChange(name, data, idx)
    } else {
      return
    }
  }

  useEffect(() => {
    if (listComodities?.length < 1) {
      getComodities()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listComodities])

  useEffect(() => {
    if (isSet) {
      const obj = {
        dataComodities: dataComodities,
        comodities: comodities,
        notes: notes,
        customNumber: customNumber,
        project: selectedProject,
        additionalFiles: additionalFiles.map((f) => f.fileUrl).filter(Boolean),
        additionalFileNames: additionalFileNames,
      }
      handleFinished(obj)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSet])

  useEffect(() => {
    if (dataComodities) {
      handleCbData({
        dataComodities,
      })
      dispatch(
        setTotal(
          dataComodities?.reduce((sum, e) => sum + (e.totalPrice ?? 0), 0),
        ),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataComodities])

  useEffect(() => {
    setDataDraft({
      dataComodities: dataComodities,
      comodities: comodities,
      notes: notes,
      customNumber: customNumber,
      additionalFiles: additionalFiles,
      additionalFileNames: additionalFileNames,
    })
  }, [dataComodities, notes, customNumber, additionalFiles, additionalFileNames])

  useEffect(() => {
    if (shouldFocus && selectRefs.current.length > 0) {
      const emptyIndex = dataComodities.findIndex((item) => !item?.comodity)

      if (emptyIndex !== -1) {
        selectRefs.current[emptyIndex]?.focus()
      } else {
        const lastIndex = selectRefs.current.length - 1
        selectRefs.current[lastIndex]?.focus()
      }

      setShouldFocus(false)
    }
  }, [shouldFocus, comodities])

  useEffect(() => {
    if (dataDraft && !isDraftLoaded) {
      const recalculated = (dataDraft.dataComodities ?? []).map((item) => {
        const price = Number(
          item?.price?.replace?.(/\./g, '')?.replace?.(/\,/g, '.') ?? 0,
        )
        const qty = Number(
          item?.quantity?.replace?.(/\./g, '')?.replace?.(/\,/g, '.') ?? 0,
        )

        return {
          ...item,
          totalPrice: price && qty ? price * qty : (item.totalPrice ?? 0),
        }
      })

      setDataComodities(recalculated)
      setComodities(dataDraft?.comodities ?? [{ id: 1 }])
      setNotes(dataDraft?.notes ?? '')
      setCustomNumber(dataDraft?.customNumber ?? '')
      setSelectedProject(dataDraft?.project ?? null)
      if (Array.isArray(dataDraft?.additionalFiles)) {
        setAdditionalFiles(dataDraft.additionalFiles)
      }
      if (Array.isArray(dataDraft?.additionalFileNames)) {
        setAdditionalFileNames(dataDraft.additionalFileNames)
      }
      setIsDraftLoaded(true)
    }
  }, [dataDraft, isDraftLoaded])

  return (
    <>
      <ModalAddProject
        isOpen={isModalOpenAddProject}
        toggle={toggleOpenCloseAddProject}
        isOutsideProject
      />
      <Card className="border-0 shadow-sm">
        <CardBody className="p-4">
          <CardTitle tag="h5" className="mb-4">
            {title}
          </CardTitle>
          {comodities?.map((comodity, index) => (
            <div key={comodity.id}>
              <FormGroup>
                <Label>Barang</Label>
                <div data-testid={`transaction-commodity-select-${index}`}>
                  <Select
                    name="comodity"
                    placeholder="Pilih barang"
                    options={listComodities}
                    onChange={(e) => {
                      handleChange('comodity', e, index)
                      handleLastPick(e)
                    }}
                    value={dataComodities[index]?.comodity ?? ''}
                    ref={(el) => (selectRefs.current[index] = el)}
                    components={{ Input: SelectInputWithTestId }}
                    data-testid={`transaction-commodity-select-${index}`}
                  />
                </div>
              </FormGroup>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Jumlah</Label>
                    <AmountInput
                      name="quantity"
                      idx={index}
                      value={dataComodities[index]?.quantity ?? ''}
                      cb={handleChangeInputSeparator}
                      placeholder="0"
                      testId={`transaction-weight-input-${index}`}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Satuan</Label>
                    <div data-testid={`transaction-unit-select-${index}`}>
                      <Select
                        options={autoFetchPublicVersion?.unitArray}
                        name="unit"
                        onChange={(e) => {
                          handleChange('unit', e, index)
                        }}
                        placeholder="Pilih satuan"
                        value={dataComodities[index]?.unit ?? ''}
                        components={{ Input: SelectInputWithTestId }}
                        data-testid={`transaction-unit-select-${index}`}
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Harga per satuan</Label>
                    <InputGroup>
                      <InputGroupText className="bg-transparent">
                        Rp
                      </InputGroupText>
                      <AmountInput
                        name="price"
                        idx={index}
                        value={dataComodities[index]?.price ?? ''}
                        cb={handleChangeInputSeparator}
                        placeholder="0"
                        dotOnly
                        testId={`transaction-price-input-${index}`}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Total Harga</Label>
                    <InputGroup>
                      <InputGroupText className="bg-transparent">
                        Rp
                      </InputGroupText>
                      <Input
                        disabled={true}
                        type="text"
                        value={intl.formatNumber(
                          isNaN(dataComodities[index]?.totalPrice)
                            ? 0
                            : (dataComodities[index]?.totalPrice ?? 0),
                          {
                            useGrouping: 'always',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          },
                        )}
                        onChange={() => {}}
                        name="totalPrice"
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              {index > 0 && (
                <div className="d-flex justify-content-end">
                  <CustomButton
                    outline
                    color="danger"
                    onClick={() => removeComodity(comodity.id)}
                    testId={`transaction-remove-commodity-${index}`}
                  >
                    <Trash2 /> Hapus
                  </CustomButton>
                </div>
              )}
              {comodities?.length > 1 && index < comodities?.length - 1 && (
                <hr />
              )}
            </div>
          ))}
          <CustomButton
            size="sm"
            style={{ maxWidth: 186 }}
            outline
            color="primary"
            onClick={handleAddComodity}
            testId="transaction-add-commodity-button"
          >
            <Plus size={16} /> Tambah Barang
          </CustomButton>
        </CardBody>
      </Card>
      <Card className="border-0 shadow-sm">
        <CardBody className="p-4">
          <CardTitle tag="h5" className="mb-4">
            Informasi Lainnya
          </CardTitle>
          <FormGroup>
            {/* <InputProject
              title="Project (Opsional)"
              onSelectProject={handleSelectedProject}
              fieldName="project"
              editValue={selectedProject?.label}
              onClickAdd={(localSearch) =>
                dispatch(setSearchProject(localSearch))
              }
              innerRef={projectRef}
              isCloseSelection={selectedProject ? true : false}
              valueName={selectedProject ? selectedProject?.label : ''}
              isCanClose
            /> */}
            <Label>Project (Opsional)</Label>
            <PMBProjectSelections
              style={{ borderColor: 'white', caretColor: 'transparent' }}
              className="border-input button w-100"
              placeholder="Pilih project"
              value={selectedProject}
              onChange={handleSelectedProject}
              testId="transaction-project-select"
            />
            {selectedProject && (
              <CustomButton
                onClick={() =>
                  window.open(
                    `${URL_PROJECTS_MENU}/${selectedProject.id}?tab=summary`,
                    '_blank',
                  )
                }
                size="sm"
                color="primary"
                className="mt-2"
                outline
                testId="transaction-project-detail-button"
              >
                <span className="d-flex align-items-center gap-1">
                  Lihat detail Project <ExternalLink size={17} />
                </span>
              </CustomButton>
            )}
          </FormGroup>
          <FormGroup>
            <Label>Nomor transaksi (opsional)</Label>
            <Input
              name="customNumber"
              onChange={(e) => {
                setCustomNumber(e.target.value ?? '')
              }}
              value={customNumber}
              placeholder="Masukkan nomor transaksi"
              data-testid="transaction-custom-number-input"
            />
            <small className="text-muted">
              Silakan tambahkan jika Anda memiliki penomoran transaksi sendiri
            </small>
          </FormGroup>
          <FormGroup>
            <Label>Catatan ke penjual (opsional)</Label>
            <Input
              type="textarea"
              style={{ minHeight: '128px' }}
              name="notes"
              onChange={(e) => {
                setNotes(e.target.value ?? '')
              }}
              value={notes}
              placeholder="Masukkan catatan jika ada"
              data-testid="transaction-notes-input"
            />
          </FormGroup>
          <FormGroup>
            <Label>Dokumen tambahan (opsional)</Label>
            <Input
              type="file"
              innerRef={docFileInputRef}
              style={{ display: 'none' }}
              onChange={handleDocFileChange}
              accept=".png, .jpeg, .jpg, .pdf, .xlsx, .xls, .doc, .docx"
              multiple
              disabled={isUploadingDoc}
            />
            <div className="d-flex flex-column text-wrap w-auto">
              <div
                className="border border-1 rounded mb-1 d-flex align-items-center"
                style={{ padding: '12px 20px' }}
              >
                <FilePlus
                  size={18}
                  className="me-2"
                  style={{
                    color: isUploadingDoc ? '#D0D5DD' : '#101828',
                    cursor: isUploadingDoc ? 'not-allowed' : 'pointer',
                  }}
                  onClick={() => docFileInputRef.current.click()}
                />

                <div
                  className="text-sm fw-bold flex-grow-1"
                  style={{
                    color: isUploadingDoc ? '#D0D5DD' : '#101828',
                  }}
                >
                  {isUploadingDoc ? (
                    <>
                      <Spinner size="sm" className="ms-2" /> Uploading ...
                    </>
                  ) : additionalFileNames?.length > 0 ? (
                    additionalFileNames.map((e, i) => (
                      <span
                        className="ms-3 badge-line"
                        key={i}
                        data-testid={`transaction-upload-doc-${e.id}`}
                      >
                        {e.fileName}
                        <X
                          size={16}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            const filteredFileNames =
                              additionalFileNames.filter(
                                (file) => file.id !== e.id,
                              )
                            const filteredFiles = additionalFiles.filter(
                              (file) => file.id !== e.id,
                            )
                            setAdditionalFileNames(filteredFileNames)
                            setAdditionalFiles(filteredFiles)
                          }}
                        />
                      </span>
                    ))
                  ) : (
                    <span
                      onClick={() => docFileInputRef.current.click()}
                      style={{
                        cursor: isUploadingDoc ? 'not-allowed' : 'pointer',
                      }}
                    >
                      Unggah Dokumen
                    </span>
                  )}
                </div>
              </div>

              <span className="text-sm text-muted">
                Jenis file yang bisa berupa .png, .jpeg, .jpg, .pdf, .xlsx,
                .xls, .doc, .docx
              </span>
            </div>
          </FormGroup>
        </CardBody>
      </Card>

      {errMsg && (
        <div>
          <small className="text-danger" data-testid="transaction-form-error-message">
            <AlertCircle size={15} /> {errMsg}
          </small>
        </div>
      )}
    </>
  )
}

export default ComodityForm
